import { memo } from 'react';
import { useAppSelector } from '../../../store/store';
import './FightSceneHeaderPanel.scss'
import bagPack from '../../../assets/img/inventory/Backpack1.png'
import bagPackWebp from '../../../assets/img/inventory/Backpack1.webp'
import ImgWithFallback from '../../ui/ImgWithFallback';

interface IHeaderPanelProp {
    handleOpenCloseCharacterWindow: () => void
    handleOpenCloseInventory: () => void
}

const FightSceneHeaderPanel = ({ handleOpenCloseCharacterWindow, handleOpenCloseInventory }: IHeaderPanelProp) => {
    const mainCharacter = useAppSelector(state => state.userReducer.character)

    return (
        <div className="fight-scene__header-panel">
            <div className="header-panel__character" onClick={handleOpenCloseCharacterWindow}>
                <ImgWithFallback
                    src={mainCharacter.getImgSmall().webp}
                    fallbackSrc={mainCharacter.getImgSmall().img} />
            </div>
            <div className="header-panel__inventory" onClick={handleOpenCloseInventory}>
                <ImgWithFallback
                    src={bagPackWebp}
                    fallbackSrc={bagPack} />
            </div>
        </div>
    );
};

export default memo(FightSceneHeaderPanel);